import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AiManagementPage } from "src/components/views/ai/management/AiManagementPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/ai/management")({
	staticData: { title: i18n.t("ai_management"), legacyViewKey: "aiManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AiManagementPage />;
}
